<template>
  <div>
    <div
      v-for="(op, key) in spellings"
      :key="key"
      class="tw-relative tw-inline-block tw-top-0 tw-left-0 tw-m-[10px]"
    >
      <a
        href=""
        v-if="results[key] === undefined"
        @click.prevent="selectOption(key)"
        class="tw-block tw-p-[10px] tw-border tw-border-solid tw-border-primary 
          tw-no-undeline hover:tw-bg-primaryvlt"
      >
        <span class="tw-inline-block">
          <span
            v-for="(s, skey) in op"
            :key="skey"
            class="tw-inline-block tw-p-[5px]"
            :class="'act-dl-cl-' + (skey + 1)"
          >
            {{ s.value }}
          </span>
        </span>
      </a>
      <span
        v-else
        class="tw-block tw-p-[10px] tw-border tw-border-solid tw-border-primary 
          tw-opacity-50"
      >
        <div>
          <div
            v-for="(s, skey) in op"
            :key="skey"
            class="tw-inline-block tw-p-[5px]"
            :class="'act-dl-cl-' + (skey + 1)"
          >
            {{ s.value }}
          </div>
        </div>
      </span>
      <div 
        v-if="results[key] !== undefined" 
        class="tw-absolute tw-top-[-12px] tw-right-[-19px]"
      >
        <ResultMark :result="results[key] > 0" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ResultMark from "./ResultMark.vue";
import { sfActivityCurrentWord } from "@/state/sfActivityState";
import { SfSyllable } from "@/types/spellingTypes";

export default defineComponent({
  components: { ResultMark },
  emits: ["success"],
  data() {
    return {
      results: [] as number[],
    };
  },
  computed: {
    spellings(): SfSyllable[][] {
      return sfActivityCurrentWord.value
        ? sfActivityCurrentWord.value.spellingOptions
        : [];
    },
  },
  methods: {
    selectOption(keyId: number) {
      let key = keyId;
      let option = this.spellings[key];
      let comp = "";
      for (let s of option) {
        comp += s.value;
      }
      let results = [...this.results];
      if (comp == sfActivityCurrentWord.value?.value) {
        results[key] = 1;
        setTimeout(() => {
          this.$emit("success");
        }, 1000);
      } else {
        results[key] = -1;
      }
      this.results = results;
    },
  },
});
</script>
